<template>
    <!-- 购买界面 -->
    <div v-loading="loading">
        <div class="header">
            <h2>确认订单</h2>
            <div style="padding: 30px; margin-top: 30px; width: 96%; min-height: 300px; height: auto; background-color: white; box-shadow: 0 6px 6px rgba(0, 0, 0, .12), 0 6px 6px rgba(0, 0, 0, .04); border-radius: 10px;">
                <span style="font-size: 16px; font-weight: 600;">商品信息</span>
                <div class="image">
                    <img :src="course.photo" alt="" width="200px">
                    <span style="padding-left: 50px; font-size: 16px;">{{ course.courseName }}</span>
                    <div style="width: 100%;">
                        <div class="row">
                            <div class="col-1"></div>
                            <div class="col-8"></div>
                            <div class="col-1"> 
                                <div style="width: 60px; height: 24px; line-height: 24px; background-color: #F36969; color: white; font-size: 14px; text-align: center; border-radius: 7px;">
                                    到手价:
                                </div>
                            </div>
                            <div class="col-1">
                                <div style="margin-bottom: 10px; width: 60px; height: 24px; line-height: 24px; color: black; font-size: 18px; border-radius: 7px;">
                                    ￥{{ course.price }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-divider></el-divider>
                   <span style="font-size:16px; padding-left: 10px;">使用优惠券</span>
                <el-divider></el-divider>
            </div>
            
        </div>
        
        <div class="container" style="margin-top: 350px;">
            <div class="row">
                <div class="col" style="width: 100px; min-height: 80px; height: auto; line-height: 70px; box-shadow: 0 6px 6px rgba(0, 0, 0, .12), 6px 6px 6px rgba(0, 0, 0, .04); border-radius: 10px; border: 1px solid lightgrey">
                    <span style="font-size: 15px;">商品总金额: ￥{{ parseInt(course.price * 1.5) }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span style="font-size: 15px;">应付金额: <span style="color:red; font-size: 20px;">￥{{ course.price }}</span></span>
                    <el-button type="danger" round style="margin-left: 66% ;" @click="clickMeToConsume">去支付</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name:'BuySystem',
        data() {
            return {
                course:{},
                loading: true,
            }
        },
        methods: {
            clickMeToConsume() {
                if (this.$route.path !== '/order/consume/' + this.$route.params.id) {
                    this.$router.push({
                        name:'consume',
                        params: {
                            id:this.$route.params.id
                        }
                    })
                }
            }
        },
        created() {
            const vue = this
            const route = this.$route
            $.ajax({
                url:'https://app6132.acapp.acwing.com.cn/api/course/read/one/',
                type:'get',
                data: {
                    id:route.params.id
                },
                success(resp) {
                    if (resp.error_message === 'success') {
                        
                        const course = JSON.parse(resp.course)
                        console.log(course)
                        vue.course = course
                        vue.loading = false
                    } 
                },
            })
        }
    }
</script>

<style scoped>
.header {
    background-image: url("https://pic.616pic.com/bg_w1180/00/19/45/DMiBRVLPd4.jpg");
    width: 100%; 
    height: 200px;
    padding: 4%;
}
.image {
    padding-top: 30px;
    padding-left: 10px;
    margin-top: 20px;
    width: 100%;
    min-height: 200px;
    height: auto;
    background-color:#F2F4F6;
}
</style>